import { MapPin, Mail, Phone, Globe } from 'lucide-react';
import { useLang } from '../i18n';
import SEO from '../components/SEO';
import { LineReveal, FadeIn } from '../components/motion';
import ContactForm from '../components/ContactForm';

const Contatti = () => {
  const { t } = useLang();

  const details = [
    { icon: MapPin, label: t('contatti.hq'), value: t('contatti.hqValue') },
    { icon: Mail, label: t('contatti.emailLabel'), value: 'info@piattiprontiglutenfree.com', href: 'mailto:info@piattiprontiglutenfree.com' },
    { icon: Phone, label: t('contatti.phoneLabel'), value: '+39 0425 544695', href: 'tel:+390425544695' },
    { icon: Globe, label: t('contatti.website'), value: 'www.piattiprontiglutenfree.com', href: 'https://www.piattiprontiglutenfree.com' },
  ];

  return (
    <main className="pt-32 md:pt-44 pb-24 md:pb-32" data-testid="contatti-page">
      <SEO page="contatti" />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <FadeIn y={16} className="mb-8">
              <span className="inline-flex items-center gap-3 font-display text-xs uppercase tracking-[0.25em] font-bold text-secondary">
                <span className="w-10 h-px bg-secondary inline-block" />
                {t('contatti.eyebrow')}
              </span>
            </FadeIn>
            <LineReveal
              lines={[<span key="1">{t('contatti.title')}</span>]}
              lineClassName="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
              className="mb-8"
            />
            <FadeIn delay={0.3}>
              <p className="text-foreground/60 text-base md:text-lg leading-relaxed max-w-md mb-14" data-testid="contatti-sub">{t('contatti.sub')}</p>
            </FadeIn>
            <FadeIn delay={0.4}>
              <h3 className="font-display text-xs uppercase tracking-[0.25em] font-bold text-secondary mb-6">{t('contatti.details')}</h3>
              <div className="grid sm:grid-cols-2 border-t border-l border-foreground/10">
                {details.map((d, i) => (
                  <div key={i} className="border-b border-r border-foreground/10 p-5" data-testid={`contact-detail-${i}`}>
                    <d.icon className="w-4 h-4 text-secondary mb-3" strokeWidth={1.5} />
                    <p className="text-xs uppercase tracking-widest text-foreground/40 mb-1 font-display font-bold">{d.label}</p>
                    {d.href ? (
                      <a href={d.href} target={d.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" className="font-medium hover:text-secondary transition-colors duration-300 break-all" data-testid={`contact-detail-link-${i}`}>{d.value}</a>
                    ) : (
                      <p className="font-medium">{d.value}</p>
                    )}
                  </div>
                ))}
              </div>
            </FadeIn>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <FadeIn delay={0.25} className="border border-foreground/10 p-8 md:p-12 bg-card">
              <ContactForm defaultTopic="generale" testIdPrefix="contact" />
            </FadeIn>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contatti;
